var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_1706_25440)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0136 18.8003L29.0936 14.227C27.8002 13.4803 26.2002 13.4803 24.8936 14.227L16.9869 18.8003C15.6936 19.547 14.8936 20.9337 14.8936 22.4403V31.5603C14.8936 33.0537 15.6936 34.4403 16.9869 35.2003L24.9069 39.7737C26.2002 40.5203 27.8002 40.5203 29.1069 39.7737L37.0269 35.2003C38.3202 34.4537 39.1202 33.067 39.1202 31.5603V22.4403C39.1069 20.9337 38.3069 19.5603 37.0136 18.8003ZM26.0002 21.3337C26.0002 20.787 26.4536 20.3337 27.0002 20.3337C27.5469 20.3337 28.0002 20.787 28.0002 21.3337V28.3337C28.0002 28.8803 27.5469 29.3337 27.0002 29.3337C26.4536 29.3337 26.0002 28.8803 26.0002 28.3337V21.3337ZM28.2269 33.1737C28.1602 33.3337 28.0669 33.4803 27.9469 33.6137C27.6936 33.867 27.3602 34.0003 27.0002 34.0003C26.8269 34.0003 26.6536 33.9603 26.4936 33.8937C26.3202 33.827 26.1869 33.7337 26.0536 33.6137C25.9336 33.4803 25.8402 33.3337 25.7602 33.1737C25.6936 33.0137 25.6669 32.8403 25.6669 32.667C25.6669 32.3203 25.8002 31.9737 26.0536 31.7203C26.1869 31.6003 26.3202 31.507 26.4936 31.4403C26.9869 31.227 27.5736 31.347 27.9469 31.7203C28.0669 31.8537 28.1602 31.987 28.2269 32.1603C28.2936 32.3203 28.3336 32.4937 28.3336 32.667C28.3336 32.8403 28.2936 33.0137 28.2269 33.1737Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1706_25440",
    x1: 27,
    y1: 54,
    x2: 27,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedFilled);
export default __webpack_public_path__ + "static/media/missedFilled.8e0041227accf9259fc0db3364d2221a.svg";
export { ForwardRef as ReactComponent };